<script
    src="../../../../../../../AppData/Local/Temp/Rar$DRa14036.14120/src/app/helper/alertTimer/alert-timer.service.ts"
></script>
<template>
  <!-- The Modal -->
  <div
      id="createModal"
      class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
              type="button"
              class="close"
              data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
              title="Create Service"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <label for="name_en">Name «<span class="text-muted">English</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Name En"
                          rules="required"
                      >
                        <b-form-input
                            id="name_en"
                            v-model="createdService.name"
                            name="name_en"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label for="descriptionAR">Name «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Name Ar"
                          rules="required"
                      >
                        <b-form-input
                            id="descriptionAR"
                            v-model="createdService.nameAR"
                            class="arabic-font"
                            name="name_ar"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                            :dir="'rtl'"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="description">Description «<span class="text-muted">English</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Description EN"
                          rules="required"
                      >
                        <b-form-textarea
                            id="descriptionEn"
                            v-model="createdService.description"
                            :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                            placeholder=""
                            rows="5"
                            cols="12"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="descriptionAr">Description «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Description Ar"
                          rules="required"
                          :dir="'rtl'"
                      >
                        <template>
                          <b-form-textarea
                              id="descriptionAr"
                              :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                              class="arabic-font"
                              v-model="createdService.descriptionAR"
                              placeholder=""
                              rows="5"
                              cols="12"
                          />
                        </template>

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="image">Image</label>
                      <validation-provider
                          #default="{ errors }"
                          name="image"
                          rules=""
                      >
                        <vue-dropzone
                            id="image"
                            @vdropzone-max-files-exceeded="resetDropzone()"
                            ref="createServiceRef"
                            :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                            name="image"
                            :options="dropzoneOptions"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="service_parent_id">Parent</label>
                      <validation-provider
                          #default="{ errors }"
                          name="service_parent_id"
                          rules=""
                      >
                        <v-select
                            class="parent-service"
                            v-model="createdService.serviceParentId"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="services"
                            :reduce="name => name.id"
                            label="name"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea,

} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vSelect from 'vue-select'
import vue2Dropzone from 'vue2-dropzone'
import { codeMultiple, codeBasic } from './code'
import FormTextAreaDefault from '../../../shared/form-textarea/FormTextAreaDefault.vue'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import companyService from '@/services/companyService'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,

    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    FormTextAreaDefault,
    vSelect,
    vueDropzone: vue2Dropzone,
  },
  props: ['services'],
  data() {
    return {
      emailValue: '',
      createdService: {
        name: '',
        nameAR: '',
        description: '',
        descriptionAR: '',
        image: '',
        serviceParentId: '',
      },
      PasswordValue: '',
      passwordCon: '',
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        dictRemoveFile: 'Remove',
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
        maxFiles: 1,

      },
      edited_service: {
        name: '',
        description: ''
      },
      codeBasic,
      selected: '',
    }
  },
  mounted() {
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate()
          .then(success => {
            if (success) {
              this.createdService.image = this.$refs.createServiceRef.getAcceptedFiles()[0]
              companyService.post(this.createdService)
                  .then(response => {
                    this.$emit('refresh', 'true')
                    this.createdService = {
                      name: '',
                      nameAR: '',
                      description: '',
                      descriptionAR: '',
                      image: '',
                      serviceParentId: '',
                    },
                        this.$refs.createServiceRef.removeAllFiles()

                    $('#createModal') .modal('hide')
                    if(response && response.status === 200){
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: 'Success',
                          icon: 'CheckIcon',
                          variant: 'success',
                          text: `Service Is Created Successfully !`,
                        },
                      })
                    }

                    this.loading = false
                  })
            }})
          .catch(
              function (error) {
                $('#createModal')
                    .modal('hide')
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'Error',
                    text: `Error !`,
                  },
                })
                return Promise.reject(error)
              }
          )
    },
    resetDropzone(){
      this.$refs.createServiceRef.removeAllFiles()

    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label {
  font-weight: bold;
}
</style>
